import styled from "styled-components";
import { Colors } from "../../config/Constants";
import { useEffect, useRef, useState } from "react";
import Button from "../Button";
import Radio from "./Radio";
import Selectfield from "../Merchant/Selectfield";
import { toast } from "react-toastify";
const filterIcon = require("../../assets/images/filter_icon.png");

interface InputProps {
    value: string;
    onChange: (value: any) => void;
    width: string;
    ghostText?: string;
    filterEntities: any;
    onFilterSelect: any;
    selectedFilter: number;
    onClearFilter: any;
    productList: any;
    onAgentSelect: any;
    onSaveFilter: any;
    agent: string;
}

interface InputFieldProps {
    value: string;
    onChange: (value: any) => void;
    width: string;
    ghostText?: string;
}

const TicketFilter = ({
    value,
    onChange,
    width,
    ghostText,
    filterEntities,
    onFilterSelect,
    selectedFilter,
    onClearFilter,
    productList,
    onAgentSelect,
    onSaveFilter,
    agent
}: InputProps) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const adjustedSelectedFilter = selectedFilter === 0 ? 0 : (selectedFilter === 2 || selectedFilter === 3 ? selectedFilter : 2);
    const useOutsideAlerter = (ref: any) => {
        useEffect(() => {
            function handleClickOutside(event: any) {
                if (ref.current && !ref.current.contains(event.target)) {
                    if (showDropdown) {
                        toast.warn("Kindly click Save to apply the changes.");
                        setShowDropdown(true);
                    } else {
                        setShowDropdown(false);
                    }
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref, showDropdown]);
    };
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);
    return (
        <FilterContainer width={width} ref={wrapperRef}>
            <StyledInput
                width="100%"
                type="text"
                value={value}
                className="custom-input"
                onChange={(e) => onChange(e.target.value)}
                onClick={() => setShowDropdown(true)}
                placeholder={ghostText || "Select filter"}
                readOnly
            />
            {showDropdown && (
                <FilterDropDown>
                    <FilterHeader>
                        <div>Filter</div>
                        <Button
                            width="4rem"
                            fontColor={Colors.red}
                            onClick={onClearFilter}
                            label="Clear"
                            outlineColor="transparent"
                        />
                    </FilterHeader>
                    <FilterListContainer>
                        {filterEntities.map((entity: any, index: any) => (
                            <Radio
                                key={index}
                                index={index}
                                selected={index === selectedFilter}
                                label={entity.label}
                                onChange={() => onFilterSelect(index)}
                            />
                        ))}
                        {selectedFilter === 1 &&
                            <DropdownContainer>
                                <Selectfield
                                    onChange={onAgentSelect}
                                    disabled={false}
                                    data={productList}
                                    name={"product"}
                                    value={agent}
                                />
                            </DropdownContainer>
                        }
                    </FilterListContainer>
                    <FilterAction>
                        <Button
                            onClick={() => {
                                setShowDropdown(false);
                                onSaveFilter();
                            }}
                            label="Save"
                            color={Colors.red}
                            outlineColor={Colors.red}
                            fontColor={Colors.white}
                        />
                        <Button
                            onClick={() => setShowDropdown(false)}
                            label="Cancel"
                            outlineColor={Colors.red}
                            fontColor={Colors.red}
                        />
                    </FilterAction>
                </FilterDropDown>
            )}
        </FilterContainer >
    );
};

interface InputProps {
    width: string;
    ghostText?: string;
}
interface FilterProps {
    width: string;
}

const FilterListContainer = styled.div`
  margin: 1rem 0;
  margin-top: 0.25rem;
`;
const FilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const FilterAction = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const FilterContainer = styled.div<FilterProps>`
  position: relative;
  width: ${(props) => props.width};
  @media only screen and (max-width: 1024px) {
    width: 100%
  }
`;
const FilterDropDown = styled.div`
  position: absolute;
  padding: 0.5rem 1rem;
  background: white;
  border: 1px solid ${Colors.athensGray};
  width: 100%;
  border-radius: 0.25rem;
  margin-top: 0.25rem;
  @media only screen and (max-width: 1024px) {
    width: 90%;
  }

`;

const StyledInput = styled.input<InputFieldProps>`
  opacity: 1;
  display: block;
  background: ${`url(${filterIcon}) no-repeat right`};
  background-position: calc(100% - 0.625rem);
  margin-top: 0.5rem;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  border-radius: 0.25rem;
  width: ${(props) => (props.width ? props.width : "100%")};
  height: 2.6875rem;
  font-family: "Poppins-Medium";
  font-size: 0.8125rem;
  border: 0.0625rem solid rgb(228, 230, 238);
  padding: 0 0.5rem;
  box-sizing: border-box;
  color: ${Colors.secondaryBlack};
  :focus {
    outline: none;
  }
  ::placeholder {
    font-family: "Poppins-Book";
    font-size: 0.8125rem;
    color: ${Colors.cloudyGrey};
  }
`;
const DropdownContainer = styled.div`
  margin-left: 1.5rem; /* Adjust margin for alignment */
  margin-bottom: 0.5rem;
`;

const Divider = styled.div`
  border-bottom: 1px solid ${Colors.athensGray};
  margin: 1rem 0;
`;

const FilterSubHeader = styled.div`
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
`;



export default TicketFilter;
